import { loadCrate } from '@nackle/umbrella';
import cypherSDK from '@nackle/cypher-sdk';
export const CMX_API_ROOT = '/v2/cmx';
function getEnvironment() {
    if ( /localhost/.test( window.location.hostname ) ) {
        return 'qa';
    }
    return window.location.hostname.toLowerCase().split( '.' ).find( function ( chunk ) {
        return [ 'ci', 'dev', 'qa', 'pprd' ].indexOf( chunk ) >= 0;
    } );
}

function getURL( url ) {
    const env = getEnvironment();
    return url.toLowerCase().replace( '(env.)', env ? env + '.' : '' );
}

export const currentEnv = getEnvironment();
export const cypherUrl = getURL( 'https://(env.)api.biw.cloud/v1/cypher' );

function CypherService( access_token, apiRootUrl ) {
     const fetchWithAuth = function ( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                'authorization': `Bearer ${ access_token }`
            }
        };

        return fetch( url, options );
    };
    const cypherUrl = `${ apiRootUrl }/v1/cypher`;
    const sdk = new cypherSDK( cypherUrl, fetchWithAuth );
    return {
        getStencilInstancesByCodesAndLocales: sdk.getStencilInstancesByCodesAndLocales,
        getCratesByStackCodesAndLocales: sdk.getCratesByStackCodesAndLocales
    };
}

/**
 * This function returns the translations that it receives from CMX using a promise. It
 * just calls 'listAllTranslatedProjectStrings', but it is friendlier and easier to use
 * (I think). It will create the AxiosInstance itself using the `sessionId` we provide.
 *
 * @param apiRootUrl    The URL of the Kong API root, e.g. https://qa.api.biw.cloud
 * @param sessionId     The user's session Id used to create an AxiosInstance that communicates with CMX.
 * @param projectName   The project to look up in CMX.
 * @param localeCode    The locale in the project to retrieve.
 */

export const getTranslatedProjectStrings = async (
  apiRootUrl,
  sessionId,
  projectName,
  localeCode,
  isUmbrella = false,
  session
) => {
  if ( sessionId === null ) {
    throw new Error( "The 'Session ID' you provided is null." );
  }
  // loadCrate expects: crateNames (array), locale (string), options (object)
   
   let response;
  try {

        if ( isUmbrella ) {
            // Umbrella Version: Use Umbrella Package to fetch translations based on project name and locale
            response = await loadCrate( projectName, localeCode );
        } else {
            // Standalone Version: Use Cypher SDK to fetch translations based on stack codes and locales
            const cypher = CypherService( session?.access_token, apiRootUrl );
            const result = await cypher.getCratesByStackCodesAndLocales(
                 projectName,
            localeCode );
            response = Object.values( result?.crates || {} ).reduce( ( acc, crate ) => {
            const localeData = crate?.[ localeCode ] || {};
            return { ...acc, ...localeData };
          }, {} );
        }
        return response;
  } catch ( e ) {
    throw new Error( 'Unable to fetch crate: ' + ( e?.message || e ) );
  }
};
